<template>
  <div class="text-body text-black-2 inline-flex flex-col items-start gap-2">
    <div class="inline-flex place-items-center gap-2">
      {{ trafficDistribution }}%
      <template v-if="trafficError">
        <RfStatusIcon class="fill-vermillion-50 m-auto h-5! w-5!" />
        Must add up to 100%
      </template>
      <RfCheckIcon v-else class="m-auto h-5! w-5! fill-green-50" />
    </div>
    <div class="ml-2 grid gap-x-2 gap-y-2" style="grid-template-columns: auto auto 1fr">
      <template v-for="variant in variationsGrouped.true" :key="variant.id">
        <span>Control</span><span>-</span><span>{{ variant.traffic_percent || 0 }}%</span>
      </template>
      <template v-for="variant in variationsGrouped.false" :key="variant.id">
        <span>{{ variant.name }}</span
        ><span>-</span><span>{{ variant.traffic_percent || 0 }}%</span>
      </template>
    </div>
  </div>
</template>

<script setup>
import RfCheckIcon from "@/components/icons/RfCheckIcon.vue";
import RfStatusIcon from "@/components/icons/RfStatusIcon.vue";
import { groupBy } from "@/utils/arrayUtils";
import { computed } from "vue";

const props = defineProps({ variations: { type: Array, default: () => [] } });

const trafficDistribution = computed(() =>
  props.variations.reduce((acc, item) => acc + (Number(item.traffic_percent) || 0), 0),
);
const trafficError = computed(() => trafficDistribution.value !== 100);

const variationsGrouped = computed(() => groupBy(props.variations || [], "is_control"));
</script>
